var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139,
    height: 150,
    viewBox: "0 0 139 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4",
    "data-name": 4,
    transform: "translate(-269 -2872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455",
    transform: "translate(8)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 69.5,
    cy: 69.5,
    r: 69.5,
    transform: "translate(261 2880)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(322 2872)",
    fill: "#f36822"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(344 3007)",
    fill: "#1c3557"
  })), /*#__PURE__*/React.createElement("g", {
    id: "app",
    transform: "translate(308.75 2918.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4633",
    "data-name": "Path 4633",
    d: "M54.012,4.75H5.488a.735.735,0,0,0-.738.731v35.31a.735.735,0,0,0,.738.731H26.575l-1.087,6.334a5.765,5.765,0,0,0-4.873,5.663.735.735,0,0,0,.738.731H51.48a3.258,3.258,0,0,0,3.27-3.237V5.481A.735.735,0,0,0,54.012,4.75ZM6.227,6.212H53.273v16.3a3.256,3.256,0,0,0-1.055-.447V7.987a.735.735,0,0,0-.738-.731H8.02a.735.735,0,0,0-.738.731V35.778a.735.735,0,0,0,.738.731H34.2V40.06H6.227ZM37.474,21.981a3.275,3.275,0,0,0-2.363,1H14.476a.731.731,0,1,0,0,1.462H34.3a3.2,3.2,0,0,0-.1.772v1.43H14.476a.731.731,0,1,0,0,1.462H34.2v2.2H14.476a.731.731,0,1,0,0,1.462H34.2v3.273H8.758V8.718H50.742V21.981Zm-3.46,25.872-1.089-6.331H34.2v6.36c-.063-.012-.127-.019-.189-.029Zm-2.587-6.331L32.5,47.775H27l1.075-6.253Zm-5.01,7.715h6.667a4.377,4.377,0,0,1,1.12.147v1.629a3.2,3.2,0,0,0,.538,1.775H22.155A4.32,4.32,0,0,1,26.417,49.237Zm26.857,1.775a1.786,1.786,0,0,1-1.793,1.775H37.474a1.786,1.786,0,0,1-1.793-1.775V25.218a1.786,1.786,0,0,1,1.793-1.775H51.48a1.786,1.786,0,0,1,1.793,1.775Z",
    transform: "translate(0)",
    fill: "#6c6a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4634",
    "data-name": "Path 4634",
    d: "M17.481,20.93a.731.731,0,0,0-.731.731v3.759a.731.731,0,0,0,1.462,0V21.661a.731.731,0,0,0-.731-.731Z",
    transform: "translate(-6.987 -9.421)",
    fill: "#6c6a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4635",
    "data-name": "Path 4635",
    d: "M26.793,23.545h30.72a.731.731,0,1,0,0-1.462H26.793a.731.731,0,1,0,0,1.462Z",
    transform: "translate(-12.403 -10.093)",
    fill: "#6c6a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4636",
    "data-name": "Path 4636",
    d: "M57.513,30.856H26.793a.731.731,0,1,0,0,1.462h30.72a.731.731,0,1,0,0-1.462Z",
    transform: "translate(-12.403 -15.201)",
    fill: "#6c6a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4637",
    "data-name": "Path 4637",
    d: "M57.513,39.628H26.793a.731.731,0,1,0,0,1.462h30.72a.731.731,0,1,0,0-1.462Z",
    transform: "translate(-12.403 -20.309)",
    fill: "#6c6a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4638",
    "data-name": "Path 4638",
    d: "M91.881,53.462h5.013a.731.731,0,0,0,0-1.462H91.881a.731.731,0,0,0,0,1.462Z",
    transform: "translate(-49.809 -27.513)",
    fill: "#6c6a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4639",
    "data-name": "Path 4639",
    d: "M97.387,113.75H94.881a.731.731,0,0,0,0,1.462h2.506a.731.731,0,0,0,0-1.462Z",
    transform: "translate(-51.646 -63.468)",
    fill: "#6c6a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4640",
    "data-name": "Path 4640",
    d: "M92.058,72.875a4.908,4.908,0,1,0,4.908,4.908A4.908,4.908,0,0,0,92.058,72.875Zm0,8.354A3.446,3.446,0,1,1,95.5,77.783,3.446,3.446,0,0,1,92.058,81.229Z",
    transform: "translate(-47.48 -39.668)",
    fill: "#6c6a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4641",
    "data-name": "Path 4641",
    d: "M96.678,79.925l-2.127,2.127-.338-.337a.731.731,0,0,0-1.033,1.033l.854.854a.731.731,0,0,0,1.034,0l2.644-2.644a.731.731,0,0,0-1.033-1.033Z",
    transform: "translate(-50.952 -43.648)",
    fill: "#6c6a6c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.93734e49050e1c653f6cf5cad35b6088.svg";
export { ForwardRef as ReactComponent };